const AdvertisementComponent = () =>
  import("@/views/advertisement/Advertisement.vue");
const CreateAdvertisement = () =>
  import("@/views/advertisement/CreateAdvertisement.vue");
const ViewAdvertisement = () =>
  import("@/views/advertisement/ViewAdvertisement.vue");
const EditAdvertisement = () =>
  import("@/views/advertisement/EditAdvertisement.vue");

export default {
  path: "advertisement",
  meta: { label: "Advertisements" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: AdvertisementComponent,
    },
    {
      path: "partners/:id",
      name: "Advertisement",
      meta: {
        requiresAuth: true,
      },
      component: AdvertisementComponent,
    },
    {
      path: "create",
      name: "Create Ad",
      meta: {
        requiresAuth: true,
      },
      component: CreateAdvertisement,
    },
    {
      path: "view/:id",
      name: "View Ad",
      meta: {
        requiresAuth: true,
      },
      component: ViewAdvertisement,
    },
    {
      path: "edit/:id",
      name: "Edit Ad",
      meta: {
        requiresAuth: true,
      },
      component: EditAdvertisement,
    },
  ],
};
